export interface HeifImage {
  get_width(): number;
  get_height(): number;
  display(imageData: ImageData, callback: (displayData: ImageData) => void);
  free(): void;
}

export declare class HeifDecoder {
  decode(buffer: ArrayBuffer): HeifImage[];
}

export type Constructor<T> = {
  new (): T;
};

export type LibHeif = {
  HeifDecoder: Constructor<HeifDecoder>;
};

export function getHeifDecoder() {
  return new (((self || window) as any).libheif as LibHeif).HeifDecoder();
}
